/**
 * QuickSight Dashboard Configuration
 * Contains the embedded dashboard URL and related settings
 */

export const QUICKSIGHT_DASHBOARD_CONFIG = {
  // QuickSight Dashboard URL
  dashboardUrl: 'https://us-east-1.quicksight.aws.amazon.com/sn/embed/share/accounts/789749947399/dashboards/8448a948-2c2d-49c0-bf47-ad3198f38e30?directory_alias=ador',
  
  // Dashboard display settings
  title: 'Monitor & Alert',
  description: 'Manufacturing Performance Metrics Dashboard',
  
  // Iframe settings
  iframeSettings: {
    width: '100%',
    height: '1300px',
    frameBorder: '0',
    allowFullScreen: true,
  }
};
